/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class NotificationTypeRegistry {
    static object: string = "System.Object";
    static string: string = "System.String";
    static int32: string = "System.Int32";
    static askMeSenpaiNotificationPayload: string = "Module.Base.Notifications.AskMeSenpaiNotificationPayload";
    static toDoListNotificationPayload: string = "Module.Base.Notifications.ToDoListNotificationPayload";
    static partnerlistNotificationPayload: string = "Module.Base.Notifications.PartnerlistNotificationPayload";
    static socketAuthenticationNotificationPayload: string = "Module.Base.Notifications.SocketAuthenticationNotificationPayload";
    static serverInstructionNotificationPayload: string = "Module.Base.Notifications.ServerInstructionNotificationPayload";
}
